import React from 'react';
import { TableRow, TableCell, IconButton, Link } from '@mui/material';
import { ListAlt } from '@mui/icons-material';

const UserTableRow = ({
  id,
  onClick,
  onClickProvider,
  onClickCustomer,
  onClickDetails,
  providerName = '',
  customerName = '',
  userName = '',
  email = '',
  phone = '',
  type = '',
  userClass = '',
  status = '',
  softwareRelease = '',
}) => (
  <TableRow key={id} id={id}>
    <TableCell>
      <Link tabIndex={0} onClick={() => onClickProvider()}>
        {providerName}
      </Link>
    </TableCell>
    <TableCell>
      <Link tabIndex={0} onClick={() => onClickCustomer()}>
        {customerName}
      </Link>
    </TableCell>
    <TableCell>
      <Link tabIndex={0} onClick={() => onClick()}>
        {userName}
      </Link>
    </TableCell>
    <TableCell>
      <IconButton color="secondary" onClick={onClickDetails}>
        <ListAlt className="small-icon textLeft" />
      </IconButton>
    </TableCell>
    <TableCell>{email}</TableCell>
    <TableCell>{phone}</TableCell>
    <TableCell>{type}</TableCell>
    <TableCell>{userClass}</TableCell>
    <TableCell>{status}</TableCell>
    <TableCell
      sx={{
        color: softwareRelease === 'Data Error' ? 'error.main' : 'inherit',
      }}>
      {softwareRelease}
    </TableCell>
  </TableRow>
);

export default UserTableRow;
